import {AppConsts} from 'core/AppConsts'

export class SubdomainTenantResolver {

    resolve(): string {
        const host = window.location.host;
        const parts = host.split('.');
        // if “foo.example.com” → ["foo","example","com"]
        return parts.length > 2 ? parts[0] : "";
    }

}

